import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    useTheme,
    Box,
    Chip,
    Stack,
    Typography,
} from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CloseIcon from '@mui/icons-material/Close';
import { COMMUNICATION_CHANNEL_OPTIONS } from '@shared/helpers/communication-channel';

export const CreateRecordDialog: React.FC<{
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description: string;
    setTitle: (value: string) => void;
    setDescription: (value: string) => void;
    onSave: () => void;
    channel?: string;
    setChannel?: (value: string) => void;
    showChannelPicker?: boolean;
}> = ({
    isOpen,
    onClose,
    title,
    description,
    setTitle,
    setDescription,
    onSave,
    channel = '',
    setChannel,
    showChannelPicker = false,
}) => {
    const theme = useTheme();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2 },
            }}
        >
            <DialogTitle
                sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <AddCommentIcon sx={{ mr: 1 }} />
                    תיעוד תקשורת חדש
                </Box>
                <IconButton onClick={onClose} sx={{ color: 'inherit' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                {showChannelPicker && setChannel ? (
                    <Stack gap={1} sx={{ mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            סוג התקשורת
                        </Typography>
                        <Stack direction="row" gap={0.75} flexWrap="wrap">
                            {COMMUNICATION_CHANNEL_OPTIONS.map((option) => {
                                const selected = channel === option.value;
                                return (
                                    <Chip
                                        key={option.value}
                                        label={option.label}
                                        clickable
                                        color={selected ? 'primary' : 'default'}
                                        variant={selected ? 'filled' : 'outlined'}
                                        onClick={() =>
                                            setChannel(selected ? '' : option.value)
                                        }
                                    />
                                );
                            })}
                        </Stack>
                    </Stack>
                ) : null}
                <TextField
                    fullWidth
                    label="כותרת"
                    value={title || ""}
                    onChange={(e) => setTitle(e.target.value)}
                    margin="normal"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 1,
                        },
                    }}
                />
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="תיאור"
                    value={description || ""}
                    onChange={(e) => setDescription(e.target.value)}
                    margin="normal"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 1,
                        },
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 3 }}>
                    ביטול
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                    sx={{ borderRadius: 3 }}
                    disabled={!title.trim()}
                >
                    שמירה
                </Button>
            </DialogActions>
        </Dialog>
    );
};
